export enum EventRegistrationStatus {
  Registered = 1,
  Waitlisted,
  Withdrawn,
}

export enum EventStatusTypeId {
  Draft = 1,
  Active = 2,
  Past = 3,
  Cancelled = 4,
}

export enum EventType {
  inPerson = 1,
  virtual,
}

export enum EventRegistrationTypeId {
  Team = 1,
  Individual,
  Vendor,
}

export enum FormFieldEntryType {
  TextEntry = 1,
  Dropdown,
}

export enum DefaultFormField {
  birthdate = 'Birthdate',
  gender = 'Gender',
  companyName = 'Company Name',
  primaryContactFirstName = 'Primary Contact First Name',
  primaryContactLastName = 'Primary Contact Last Name',
  primaryContactEmail = 'Primary Contact Email',
  primaryContactPhoneNumber = 'Primary Contact Phone Number',
  brandsOrProductsToBeExhibited = 'Brands Or Products to be Exhibited',
  namesOfAttendees = 'Name(s) Of Attendees',
  companyWebsite = 'Company Website',
}
